/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React from "react";
import { ContextMenuOutlineNode } from "./menus/ContextMenuOutlineNode";
import { ContextMenuScopeNode } from "./menus/ContextMenuScopeNode";

export const contextMenuRegister = {
	outlineNode: ContextMenuOutlineNode,
	scopeNode: ContextMenuScopeNode
} as const;

export type TContextMenuId = keyof typeof contextMenuRegister;

export type TGetContextMenuParams<TId extends TContextMenuId> = React.ComponentProps<
	typeof contextMenuRegister[TId]
>;
